import React from 'react'

class Get extends React.Component {
  render() {
    return (
  <section id="Contact">
    <div class="container col-md-4 text-center">
       <h1 data-aos="fade-down">Get in Touch</h1>
          <p>I'm Open To Freelance, Part Time And Junior Developer Roles. Have you got a question or project in mind?<br />  feel free to reach out to me.</p>
              <a href="mailto:justinedobor77@gmail.com"><button className="index_contact_btn">Send an Email</button></a>
    </div>  
   </section>    
    )
  }
}

export default Get;


